<fm-balloon-header>
  <fm-harsh-driving-event-balloon-title [classification]="balloon?.classification"></fm-harsh-driving-event-balloon-title>
  <div class="harsh-driving-event-balloon__subtitle-wrapper">
    <mat-icon class="harsh-driving-event-balloon__subtitle-icon mat-icon-size-xs" svgIcon="ic-location-pin"></mat-icon>
    <span class="harsh-driving-event-balloon__subtitle">{{ balloon?.address }}</span>
  </div>
</fm-balloon-header>
<fm-balloon-section [showDivider]="false">
  <div class="harsh-driving-event-balloon__info-row harsh-driving-event-balloon__driver-info-row">
    <div class="harsh-driving-event-balloon__info-column">
      <span class="harsh-driving-event-balloon__label"><span i18n="@@S_LIVEMAP_HDE_DRIVER">Driver</span>:</span>
      <span class="harsh-driving-event-balloon__value">{{ balloon?.driverName }}</span>
    </div>
    <fm-harsh-driving-event-balloon-badge [classification]="balloon?.classification"></fm-harsh-driving-event-balloon-badge>
  </div>
  <div class="harsh-driving-event-balloon__info-row">
    <span class="harsh-driving-event-balloon__label"><span i18n="@@S_LIVEMAP_HDE_VEHICLE">Vehicle</span>:</span>
    <span class="harsh-driving-event-balloon__value">{{ balloon?.vehicleName }}</span>
  </div>
  <div class="harsh-driving-event-balloon__info-row">
    <span class="harsh-driving-event-balloon__label"><span i18n="@@S_LIVEMAP_HDE_DATE">Date</span>:</span>
    <span class="harsh-driving-event-balloon__value">{{ balloon?.date | date: userSettings?.DateFormat }}</span>
  </div>
  <div class="harsh-driving-event-balloon__info-row">
    <span class="harsh-driving-event-balloon__label"><span i18n="@@S_LIVEMAP_HDE_TIME">Time</span>:</span>
    <span class="harsh-driving-event-balloon__value">{{ balloon?.date | date: userSettings?.TimeFormat }}</span>
  </div>
</fm-balloon-section>
<fm-balloon-actions>
  <div class="harsh-driving-event-balloon__visible-actions">
    <button
      mat-button
      *ngIf="permissions?.liveMapFindNearest !== EPermissionStatus.Disabled"
      class="vzc-small"
      id="btn-balloon-find-nearest"
      i18n="@@S_FIND_NEAREST"
      (click)="onFindNearest()"
    >
      Find Nearest
    </button>
    <button
      mat-button
      *ngIf="permissions?.directions"
      class="vzc-small"
      id="btn-balloon-directions"
      i18n="@@S_DIRECTIONS"
      (click)="onDirections()"
    >
      Directions
    </button>
    <button mat-button class="vzc-small" id="btn-balloon-back-to-video" i18n="@@S_LIVEMAP_HDE_BACK_TO_VIDEO" (click)="onBackToVideo()">
      Back to video
    </button>
  </div>
  <mat-icon
    #subMenuTrigger
    class="harsh-driving-event-balloon__sub-menu-trigger mat-icon-size-xs"
    svgIcon="ds-ic-elipsis"
    (click)="showSubMenu = !showSubMenu"
  ></mat-icon>
  <ul *ngIf="showSubMenu" #subMenu class="harsh-driving-event-balloon__sub-menu">
    <li class="harsh-driving-event-balloon__sub-menu-item" id="btn-balloon-replay" i18n="@@S_REPLAY" (click)="onReplay()">Replay</li>
  </ul>
</fm-balloon-actions>
